module.exports = __webpack_public_path__ + "img/adolescente.ae0b91a2.png";